export const BASE_URL = import.meta.env.PROD ? "https://playtest.skystrife.xyz" : "http://localhost:1337";
export const MATCH_URL = `${BASE_URL}/match`;
export const FEEDBACK_URL = `https://docs.google.com/forms/d/e/1FAIpQLSdr3pETUWFKWaZNFT1wysop1xQVz1Qp33YZXiJwI8d2DLU5Qw/viewform?usp=send_form`;
export const LATTICE_URL = `https://lattice.xyz`;
export const MUD_URL = `https://mud.dev`;
export const TWITTER_URL = `https://twitter.com/skystrifeHQ`;
export const DISCORD_URL = `https://lattice.xyz/discord`;
export const EXPLORER_URL = "https://explorer.testnet-chain.linfra.xyz";
export const HOW_TO_PLAY_URL = "https://latticexyz.notion.site/How-to-play-Sky-Strife-8c9f951c605e487cad9e8158bc641835";
